import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { env } from '../config/env'

// Make Pusher available globally for Laravel Echo
window.Pusher = Pusher

let echoInstance: Echo | null = null

export const initializeEcho = (authToken: string) => {
  if (echoInstance) {
    return echoInstance
  }

  echoInstance = new Echo({
    broadcaster: 'pusher',
    key: env.pusher.key,
    cluster: env.pusher.cluster,
    forceTLS: env.pusher.scheme === 'https',
    encrypted: true,
    authEndpoint: `${env.api.url}/v1/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: `Bearer ${authToken}`,
        Accept: 'application/json',
      },
    },
  })

  return echoInstance
}

export const getEcho = (): Echo | null => {
  return echoInstance
}

export const disconnectEcho = () => {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
  }
}

export default {
  initializeEcho,
  getEcho,
  disconnectEcho,
}
